import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBB3icgDkWY9Si8T9PvUTGo-3G4J9f5-9c",
  authDomain: "cooltorial.firebaseapp.com",
  databaseURL: "https://cooltorial.firebaseio.com",
  projectId: "cooltorial",
  storageBucket: "cooltorial.appspot.com",
  messagingSenderId: "793764598482",
  appId: "1:793764598482:web:4dd6a903fa2d6bfa6bd30b",
  measurementId: "G-PJ18QNJ386",
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export { storage };
